

















































import { Component, Prop, Vue } from 'vue-property-decorator'
import { EditorialProject, ProductionPrep } from '@/models'
import { ActionTypes } from '@/store/action-types'
import { showPrepError } from '@/utils/production-prep'

/**
 * Form of a production preparation. It emits `save` with the preparation and a `done` callback:
 * the parent saves it and calls `done(true)` to close the modal
 */
@Component
export default class UpsertProductionPrepModal extends Vue {
  @Prop({ required: false }) prep: ProductionPrep | null

  private form = { id: 0, name: '', editorialProjectId: null as string | null, notes: '' }
  private saving = false

  get editorialProjects(): EditorialProject[] {
    return [...this.$store.getters.editorialProjects]
      .sort((first: EditorialProject, second: EditorialProject) => first.name.localeCompare(second.name))
  }

  get isNew(): boolean {
    return !this.prep || !this.prep.id
  }

  async resetForm() {
    this.saving = false
    this.form = this.prep
      ? { id: this.prep.id, name: this.prep.name, editorialProjectId: this.prep.editorialProjectId || null, notes: this.prep.notes || '' }
      : { id: 0, name: '', editorialProjectId: null, notes: '' }
    try {
      await this.$store.dispatch(ActionTypes.LOAD_EDITORIAL_PROJECTS)
    } catch (error) {
      showPrepError(this, error)
    }
  }

  save() {
    if (!this.form.name.trim() || this.saving) return
    this.saving = true
    this.$emit('save', { ...this.form }, (saved: boolean) => {
      this.saving = false
      if (saved) this.$bvModal.hide('UpsertProductionPrepModal')
    })
  }
}
